import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import TrimToggle from './TrimToggle';
import themeStyles from './TrimOverview.styles';
const TrimToggleContentBox = themeStyles.apply(Box, 'TrimToggleContent');
const TrimToggleContent = ({ gtmVehicleData, isExterior, isSingleImage, isInventoryVariant, }) => (_jsx(TrimToggleContentBox, { hasMarginTop: isSingleImage, children: _jsx(TrimToggle, { gtmVehicleData: gtmVehicleData, isExterior: isExterior, isInventoryVariant: isInventoryVariant }) }));
export default TrimToggleContent;
